export const customUrlBuilderColyseus = (
  url: URL,
  serverUrl: string
): string => {
  const fromEnvUrl = new URL(serverUrl)

  if (fromEnvUrl.host !== url.host) {
    url.searchParams.set("pod_name", url.host)
    url.host = fromEnvUrl.host
  }

  return url.toString()
}
